module.exports = __webpack_public_path__ + "img/24.e0393780.jpg";